<template>
    <input
        :value="modelValue"
        @input="input"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholder"
        type="number"
        :step="step"
        class="form-control"
        :class="{[optional_class]: true}"
    >
</template>

<script>
export default {
    name: 'FormInputNumber',
    props: {
        modelValue: {
            type: Number
        },
        required: {
            type: Boolean,
            default: false
        },
        step:{
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ""
        },
        optional_class: {
            type: String,
            default: ''
        },
    },
    emits: [
        'update:modelValue'
    ],
    methods: {
        input($event) {
            let value = $event.target.value;
            if (value === '') {
                this.$emit('update:modelValue', null);
            }
            if (value.slice(-1) === '.') {
                return;
            }

            value = Number(value);
            if (Number.isNaN(value)) {
                this.$emit('update:modelValue', null);
            }

            this.$emit('update:modelValue', value);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
